import { render } from "./bufa.vue?vue&type=template&id=6b267312&scoped=true"
import script from "./bufa.vue?vue&type=script&lang=js"
export * from "./bufa.vue?vue&type=script&lang=js"

import "./bufa.vue?vue&type=style&index=0&id=6b267312&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b267312"]])

export default __exports__